import React from 'react'
import AboutPage from '../Components/AboutPage/AboutPage'

const About = () => {
  return (
    <div>
        <AboutPage/>
    </div>
  )
}
export default About